import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import useGetFacilities from './hooks/useGetFacilities'
import useGetDownload from './hooks/useGetDownload'
import useGetFinalDownload from './hooks/useGetFinalDownload'
import useCheckTask from './hooks/useCheckTask'
interface IModalProps {
    show: boolean
    onHide: () => void
    moneyPool: string | undefined
    setIsOpenExcelModalEmail: React.Dispatch<React.SetStateAction<boolean>>
    setFullReportCount: React.Dispatch<React.SetStateAction<number>>
}
export default function DownloadExcelModal({
    show,
    onHide,
    moneyPool,
    setIsOpenExcelModalEmail,
    setFullReportCount,
}: IModalProps) {
    const [task, setTask] = useState<string>('')
    const { isLoading, mutate } = useGetFacilities(
        setIsOpenExcelModalEmail,
        setFullReportCount
    )
    const { mutate: FinalMutate } = useGetFinalDownload()
    const { mutate: CheckMutate } = useCheckTask(FinalMutate, task)
    const { mutate: downloadMutate } = useGetDownload(setTask, CheckMutate)
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" mb-3">دریافت اکسل گزارش صندوق</p>
                <hr />
                <p
                    className=" my-3 text-green-1  cursor-pointer "
                    onClick={() => {
                        onHide()
                        mutate(moneyPool)
                    }}
                >
                    ارسال از طریق ایمیل
                </p>
                <hr />
                {/* <p
                    className=" my-3 text-green-1  cursor-pointer"
                    onClick={() => {
                        downloadMutate(moneyPool)
                    }}
                >
                    دانلود مستقیم
                </p>
                <hr /> */}
                <p className=" my-3  cursor-pointer" onClick={onHide}>
                    بازگشت
                </p>
            </div>
        </Modal>
    )
}
